module.exports = __webpack_public_path__ + "img/img02.6fd192cd.jpg";